import { call, put, takeLatest } from "redux-saga/effects";
import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import { presetsAPI } from "../api/api";
import { PresetsActionTypes } from "../actions/actionTypes";

function* getDenominations(action: Action) {
    try {
        const denominations = yield call(() => presetsAPI.getDenominations());

        yield put({
            type: PresetsActionTypes.GET_DENOMINATIONS_SUCCESS,
            payload: denominations.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Denominations.");

        yield put({
            type: PresetsActionTypes.GET_DENOMINATIONS_FAIL,
            payload: e
        });
    }
}

export function* getDenominationsWatcher() {
    yield takeLatest(PresetsActionTypes.GET_DENOMINATIONS, getDenominations);
}
